<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div class="iconfont">
        <img :src="(item.url === $route.path ? item.icon2 : item.icon1)" />
      </div>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require('@/assets/images/footer-icon1.png'),
          icon2: require('@/assets/images/footer-checked1.png'),
          url: "/home"
        },
        // {
        //   name: "分类",
        //   icon1: "icon-yingyongchengxu-xianxing",
        //   icon2: "icon-yingyongchengxu",
        //   url: "/category"
        // },
        {
          name: "购物车",
          icon1: require('@/assets/images/footer-icon2.png'),
          icon2: require('@/assets/images/footer-checked2.png'),
          url: "/cart"
        },
        {
          name: "我的",
          icon1: require('@/assets/images/footer-icon3.png'),
          icon2: require('@/assets/images/footer-checked3.png'),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
